(function () {
  'use strict';

  function isSwymDrawerOpen() {
    var container = document.getElementById('swym-storefront-layout-container');
    if (!container) return false;
    var style = window.getComputedStyle(container);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function isCartAddUrl(url) {
    return typeof url === 'string' && url.indexOf('cart/add') !== -1;
  }

  function openThemeCart() {
    document.dispatchEvent(new CustomEvent('cart:reload', { bubbles: true }));
    setTimeout(function () {
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    }, 300);
  }

  var originalFetch = window.fetch;
  window.fetch = function (url, options) {
    var urlStr = (typeof url === 'string') ? url : (url instanceof Request ? url.url : String(url));
    var method = (options && options.method) ? options.method.toUpperCase() : 'GET';
    var shouldIntercept = method === 'POST' && isCartAddUrl(urlStr) && isSwymDrawerOpen();

    var promise = originalFetch.apply(this, arguments);

    if (shouldIntercept) {
      promise.then(function (response) {
        if (response.ok) {
          openThemeCart();
        }
      });
    }

    return promise;
  };

  var originalXhrOpen = XMLHttpRequest.prototype.open;
  var originalXhrSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._snMethod = (method || 'GET').toUpperCase();
    this._snUrl = url;
    return originalXhrOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    var shouldIntercept = this._snMethod === 'POST' && isCartAddUrl(this._snUrl || '') && isSwymDrawerOpen();

    if (shouldIntercept) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          openThemeCart();
        }
      });
    }

    return originalXhrSend.apply(this, arguments);
  };
})();
